// Drag global: qualquer .modal-conteudo pode ser arrastado pelo seu .modal-header.
// Aplica via transform translate aditivo. Cliques em .btn-fechar-modal nao iniciam
// drag (continuam fechando o modal). Cobre mouse + touch via pointer events.
//
// Limites verticais: o TOPO do modal sempre fica visivel — nunca passa acima do
// topo da viewport, e nunca desce alem de (vh - HEADER_VISIVEL) pra deixar o
// cabecalho clicavel pro usuario arrastar de volta. Limites horizontais: deixa
// pelo menos MARGIN_LATERAL px do modal visiveis em cada borda esquerda/direita.

const MARGIN_LATERAL = 80;
const HEADER_VISIVEL = 60;

interface DragState {
  conteudo: HTMLElement;
  pointerId: number;
  origemCursorX: number;
  origemCursorY: number;
  origemTransX: number;
  origemTransY: number;
}

let estado: DragState | null = null;

function lerTransAtual(el: HTMLElement): { x: number; y: number } {
  const m = /translate\(\s*(-?\d+(?:\.\d+)?)px\s*,\s*(-?\d+(?:\.\d+)?)px\s*\)/.exec(el.style.transform || '');
  if (!m) return { x: 0, y: 0 };
  return { x: Number(m[1]), y: Number(m[2]) };
}

function onPointerDown(e: PointerEvent) {
  if (e.button !== 0 && e.pointerType === 'mouse') return;
  const target = e.target as HTMLElement | null;
  if (!target) return;
  const header = target.closest('.modal-header') as HTMLElement | null;
  if (!header) return;
  // Cliques no botao X NAO iniciam drag
  if (target.closest('.btn-fechar-modal')) return;
  // Cliques em outros botoes/inputs dentro do header tbm nao
  if (target.closest('button, input, select, textarea, a')) return;
  const conteudo = header.parentElement as HTMLElement | null;
  if (!conteudo || !conteudo.classList.contains('modal-conteudo')) return;
  // Modal em tela cheia (DA-456) ja ocupa a viewport inteira: arrastar so teria como
  // efeito tirar pedaco dele da tela. Nao ha pra onde mover.
  if (conteudo.dataset.modalTelaCheia === 'true') return;

  const trans = lerTransAtual(conteudo);
  estado = {
    conteudo,
    pointerId: e.pointerId,
    origemCursorX: e.clientX,
    origemCursorY: e.clientY,
    origemTransX: trans.x,
    origemTransY: trans.y,
  };
  conteudo.classList.add('modal-arrastando');
  // Captura o pointer pra continuar recebendo eventos mesmo se cursor sair do header
  try { header.setPointerCapture(e.pointerId); } catch { /* ignore */ }
  e.preventDefault();
}

function onPointerMove(e: PointerEvent) {
  if (!estado || e.pointerId !== estado.pointerId) return;
  const dx = e.clientX - estado.origemCursorX;
  const dy = e.clientY - estado.origemCursorY;
  const novoX = estado.origemTransX + dx;
  const novoY = estado.origemTransY + dy;
  // Limita pra deixar margin visivel em cada lado
  const r = estado.conteudo.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  // Posicao atual (sem o novo translate aplicado): subtrai trans atual ja aplicado
  const transAtual = lerTransAtual(estado.conteudo);
  const baseX = r.left - transAtual.x;
  const baseY = r.top - transAtual.y;
  // Horizontal: pelo menos MARGIN_LATERAL do modal visivel em cada borda.
  const minTransX = -(baseX + r.width - MARGIN_LATERAL);
  const maxTransX = vw - baseX - MARGIN_LATERAL;
  // Vertical: o TOPO do modal nunca sai pelo topo da viewport (cabecalho preso
  // atras do header global = nao consegue mais arrastar). E nunca desce alem de
  // (vh - HEADER_VISIVEL) pra deixar o cabecalho acessivel embaixo.
  const minTransY = -baseY;
  const maxTransY = vh - HEADER_VISIVEL - baseY;
  const clampedX = Math.max(minTransX, Math.min(maxTransX, novoX));
  const clampedY = Math.max(minTransY, Math.min(maxTransY, novoY));
  estado.conteudo.style.transform = `translate(${clampedX}px, ${clampedY}px)`;
}

function onPointerUp(e: PointerEvent) {
  if (!estado || e.pointerId !== estado.pointerId) return;
  estado.conteudo.classList.remove('modal-arrastando');
  estado = null;
}

let instalado = false;

export function instalarModalDrag(): void {
  if (instalado) return;
  instalado = true;
  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('pointermove', onPointerMove, true);
  document.addEventListener('pointerup', onPointerUp, true);
  document.addEventListener('pointercancel', onPointerUp, true);
}
